import features from '../ruleset/features';
import { Minigame } from '.';
import {
  coinsLessThanToUnlockMinigames,
  MinigameType,
} from './minigame.ruleset';

export const minigameGetters = ({
  Care,
  Tutorial,
  Inventory,
}: Minigame['$DEPENDENCIES']) => (state: Minigame.State) => ({
  areMinigamesAvailable: () => {
    const { isTutorialStepComplete } = Tutorial.getters(state);
    if (isTutorialStepComplete('match3')) {
      // Feature already unlocked
      return true;
    }

    if (Care.getters(state).getCareActionCount() >= 2) {
      // Player meets unlock requirements
      return true;
    }

    // Grant special access to players who might be unable to meet unlock requirements
    return (
      isTutorialStepComplete('basicGameplay') &&
      Inventory.getters(state).getPoints() < coinsLessThanToUnlockMinigames
    );
  },

  isMinigameAvailable: (minigame: MinigameType) =>
    minigameGetters(Minigame.$DEPENDENCIES)(state).areMinigamesAvailable() &&
    !isMinigameDisabled(minigame, features(state)),

  getMinigameCount: () => state.minigame.minigameCount,
});

const isMinigameDisabled = (
  minigame: MinigameType,
  flags: ReturnType<typeof features>,
) => minigame in flags && !flags[minigame];
